<template>
  <div>
    <div class="delivery-title left" v-if="window.width > 1003">
      <h1>{{ $t("deliveryPointsName") }}</h1>
      <p>{{ $t("deliveryPointsDescription") }}</p>
    </div>
    <!-- <div class="right">
      <a href="#" class="notification-action">Add a new delivery point</a>
    </div>-->
    <br clear="all" />
    <!-- <div class="tabs-container">
      <div class="tabs">
        <a v-for="(entry, index) in customer.products" :key="entry.name" @click="selectProduct(index)"
          :class="entry.name === selectedProduct.name && 'active'">
          <img :class="entry.paper === 2 && 'cadhoc'" :src="require('@/assets/images/logo-up-' +
            (entry.card ? entry.card : entry.paper) +
            '.png')
          " />
        </a>
      </div>
    </div>
    <div align="center" class="select-left">
      <select class="mobile" @change="selectedProductMobile">
        <option v-for="(entry, index) in customer.products" :key="index" :value="index"
          :selected="isSelectedProduct(entry)">{{ entry.name }}</option>
      </select>
    </div> -->
    <div class="content-delivery">
      <div class="second-tabs">
        <div v-for="(point, index) in addressPoints" :key="index">
          <div class="grey-info">
            <b-container fluid class="border-box">
              <form @submit.prevent="
                                                            {
                return false;
              }
                ">
                <b-row class="border-box address-title">
                  <b-col xl="9" md="9" class="border-box">
                    <h3>
                      {{ point.codcom }} -
                      {{ point.name ? point.name : point.address.locality }}
                    </h3>
                  </b-col>
                </b-row>
                <b-row class="border-box">
                  <b-col xl="12" md="12" class="border-box" :class="window.width > 767 &&
                    'col-xl-12 col-md-12'
                    ">
                    <b-row class="border-box">
                      <b-col class="border-box" xl="12" md="12">
                        <p class="title-address-table">
                          <strong>{{ $t("deliveryPointAddressTitle") }}</strong>
                        </p>
                        <p>
                          <small>{{ $t("deliveryPointAddressStreet") }}</small>
                          <br />
                          <input v-if="point !== selectedPoint" type="text" v-model="point.address.street_name"
                            class="formedituser" maxlength="64" disabled />
                          <input v-else type="text" v-model="selectedPoint.address.street_name" class="formedituser"
                            maxlength="39" @keyup="updateInputCharacters()" />
                        </p>
                        <p>
                          <small>{{
                            $t("deliveryPointAddressStreetDetail")
                          }}</small>
                          <br />
                          <input v-if="point !== selectedPoint" type="text" v-model="point.address.street_detail"
                            class="formedituser" maxlength="39" disabled />
                          <input v-else type="text" v-model="selectedPoint.address.street_detail" class="formedituser"
                            maxlength="39" @keyup="updateInputCharacters()" />
                        </p>
                      </b-col>
                      <b-col class="border-box" xl="6" md="6">
                        <p>
                          <small>{{ $t("deliveryPointAddressCity") }}</small>
                          <br />
                          <input v-if="point !== selectedPoint" disabled type="text" v-model="point.address.locality"
                            class="formedituser" />
                          <input v-else type="text" v-model="selectedPoint.address.locality" class="formedituser"
                            maxlength="39" @keyup="updateInputCharacters()" />
                        </p>
                      </b-col>
                      <b-col class="border-box" xl="6" md="6">
                        <p>
                          <small>
                            {{ $t("deliveryPointAddressPostalCode") }}
                          </small>
                          <br />
                          <input v-if="point !== selectedPoint" disabled type="text" v-model="point.address.postal_code"
                            class="formedituser" />
                          <input v-else type="text" v-model="selectedPoint.address.postal_code" class="formedituser"
                            maxlength="39" @keyup="updateInputCharacters()" />
                        </p>
                      </b-col>
                    </b-row>
                    <b-row class="border-box">
                      <b-col class="border-box" xl="12" md="12">
                        <p class="title-address-table">
                          <strong>{{ $t("deliveryPointContactTitle") }}</strong>
                        </p>
                      </b-col>
                      <b-col class="border-box" xl="12" md="12">
                        <p>
                          <small>{{
                            $t("deliveryPointContactFullName")
                          }}</small>
                          <br />
                          <input v-if="point !== selectedPoint" disabled type="text" v-model="point.person.first_name"
                            class="formedituser" />
                          <input v-else type="text" v-model="selectedPoint.person.first_name" class="formedituser"
                            maxlength="32" @keyup="updateInputCharacters()" />
                        </p>
                      </b-col>
                    </b-row>
                    <b-row class="border-box">
                      <b-col class="border-box" xl="6" md="6">
                        <p>
                          <small>{{ $t("deliveryPointContactMobile") }}</small>
                          <br />
                          <input v-if="point !== selectedPoint" disabled type="text" v-model="point.person.mobile_phone"
                            class="formedituser" />
                          <input v-else type="text" v-model="selectedPoint.person.mobile_phone" class="formedituser"
                            @keyup="updateInputCharacters()" />
                        </p>
                      </b-col>
                      <b-col class="border-box" xl="6" md="6">
                        <p>
                          <small>{{ $t("deliveryPointContactEmail") }}</small>
                          <br />
                          <input v-if="point !== selectedPoint" disabled type="text" v-model="point.person.email"
                            class="formedituser" />
                          <input v-else type="text" v-model="selectedPoint.person.email" class="formedituser"
                            maxlength="54" @keyup="updateInputCharacters()" />
                        </p>
                      </b-col>
                    </b-row>
                    <br clear="all" />
                    <b-row class="border-box" v-if="point !== selectedPoint && customer && onlyForAdmin(userRole)">
                      <b-col class="border-box" md="12">
                        <p>
                          <a class="
                                notification-action
                                custom-notification-action
                              " @click="editAddressPoint(index)">{{ $t("editButtonLabel") }}</a>
                        </p>
                      </b-col>
                    </b-row>
                    <b-row class="border-box" v-if="point === selectedPoint && customer && onlyForAdmin(userRole)">
                      <b-col class="border-box" cols="6" md="6">
                        <p>
                          <a class="notification-action" @click="submitAddressPoint()">{{
                            $t("saveChangesLabel") }}</a>
                        </p>
                      </b-col>
                      <b-col class="border-box" cols="6" md="6">
                        <p class="line-height-43 text-right">
                          <a class="resetButton" @click="resetAddressPoint(point)">
                            <i>{{ $t("cancelChangesLabel") }}</i>
                          </a>
                        </p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </form>
            </b-container>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="modal_popup_confirm" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirm', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        {{
          $t("warningCardAddressPoint")
        }}
        <br />
        <br />
        <a class="notification-action" @click="submitAddressPoint()">{{
          $t("saveChangesLabel")
        }}</a>
      </div>
    </div> -->
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.sendAddressError">
          <p>{{ $t("errorSentAddressPoint_" + this.sendAddressError.code) }}</p>
        </div>
        <div v-else>
          <p>{{ $t("sentAddressPointSuccess") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpServiceUser from "@/http/http-user.js";
import Cookies from "js-cookie";
import { BContainer, BRow, BCol } from "bootstrap-vue";
import validator from "@/plugins/fieldValidation.js";

export default {
  props: {
    customer: Object,
    userRole: String
  },
  components: {
    "b-container": BContainer,
    "b-row": BRow,
    "b-col": BCol
  },
  data() {
    return {
      selectedProduct: null,
      addressPoints: null,
      window: {
        width: 0,
        height: 0
      },
      editMode: false,
      selectedPoint: null,
      sendAddressError: null
    };
  },
  methods: {
    selectProduct(index) {
      this.selectedProduct = this.customer.products[index];
      this.getAddressPoints();
    },
    isSelectedProduct(product) {
      return product + "" === this.selectedProduct;
    },
    selectedProductMobile(event) {
      this.selectedProduct = this.customer.products[event.target.value];
      this.getAddressPoints();
    },
    showModalPopup(elementId, show) {
      if (show) {
        document.getElementById(elementId).style.visibility = "visible";
      } else {
        document.getElementById(elementId).style.visibility = "hidden";
      }
    },
    getAddressPoints() {
      // this.showModalPopup("modal_popup_loading", true);

      this.editMode = false;
      this.selectedPoint = null;
      this.sendAddressError = null;
      var params = "?per_page=" + 10000 + "&page=" + 1;

      httpServiceUser.userService
        .getAddressPoints(
          this.customer.company_id,
          params,
          Cookies.get("token")
        )
        .then(response => {
          if (response.status == 200) {
            this.addressPoints = response.data.results;
          } else if (response.status == 400 || response.status == 403) {
            return null;
          } else {
            return null;
          }
          // this.showModalPopup("modal_popup_loading", false);
        })
        .catch(function () {
          // this.showModalPopup("modal_popup_loading", false);
        });
    },
    editAddressPoint(index) {
      this.editMode = true;
      this.selectedPoint = this.addressPoints[index];
    },
    resetAddressPoint(addressPoint) {
      this.formData = addressPoint;
      this.selectedPoint = null;
      this.editMode = false;
    },

    onlyAlphabetCharacters(variable) {
      if (/^[a-zA-Z]*$/i.test(variable)) {
        return variable;
      } else {
        return variable.replace(/[0-9&\/\\|`#@\[\]\-,+=()$~%.'":*!?<>{}]/g, "");
      }
    },
    onlyNumericCharacters(variable) {
      if (/^[0-9]*$/i.test(variable)) {
        return variable;
      } else {
        return variable.replace(
          /[a-zA-Z&\/\\|`#@\[\]\-,+=()$~%.'":*!?<>{}]/g,
          ""
        );
      }
    },
    onlyAlphaNumericCharacters(variable) {
      if (/^[a-zA-Z0-9@.-]*$/i.test(variable)) {
        return variable;
      } else {
        return variable.replace(/[&\/\\|`#\[\]\-,+=()$~%'":*!?<>{}]/g, "");
      }
    },
    updateInputCharacters() {
      this.selectedPoint.address.street_name = this.onlyAlphaNumericCharacters(
        this.selectedPoint.address.street_name
      );
      this.selectedPoint.address.street_detail = this.onlyAlphaNumericCharacters(
        this.selectedPoint.address.street_detail
      );
      this.selectedPoint.person.first_name = this.onlyAlphabetCharacters(
        this.selectedPoint.person.first_name
      );
      this.selectedPoint.person.mobile_phone = this.onlyNumericCharacters(
        this.selectedPoint.person.mobile_phone
      );
      this.selectedPoint.person.email = this.onlyAlphaNumericCharacters(
        this.selectedPoint.person.email
      );
      this.$forceUpdate();
    },

    submitAddressPoint() {
      this.sendAddressError = null;
      this.showModalPopup("modal_popup_loading", true);

      if (
        this.selectedPoint.address.street_name.length === 0 ||
        this.selectedPoint.address.street_name.length > 38
      ) {
        this.sendAddressError = { code: "STREET_NAME_TOO_LONG" };
        this.closeAndOpenPopup();
        return;
        } else if (this.selectedPoint.address.street_detail.length > 38
      ) {
        this.sendAddressError = { code: "STREET_DETAIL_TOO_LONG" };
        this.closeAndOpenPopup();
        return;
      } else if (this.selectedPoint.person.first_name.length === 0) {
        this.sendAddressError = { code: "NO_LENGTH_FIRSTNAME" };
        this.closeAndOpenPopup();
        return;
      } else if (
        this.selectedPoint.person.email && this.selectedPoint.person.email.length === 0 && !validator.validateEmail()
      ) {
        this.sendAddressError = { code: "NO_LENGTH_EMAIL" };
        this.closeAndOpenPopup();
        return;
      } else if (
        this.selectedPoint.person.mobile_phone && this.selectedPoint.person.mobile_phone.length === 0 && !validator.validateMobilePhone()) {
        this.sendAddressError = { code: "NO_LENGTH_MOBILE" };
        this.closeAndOpenPopup();
        return;
      } else {
        this.selectedPoint.address.street_name = this.selectedPoint.address.street_name
          .toUpperCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");
          this.selectedPoint.address.street_detail = this.selectedPoint.address.street_detail
          .toUpperCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");
        this.selectedPoint.person.first_name = this.selectedPoint.person.first_name
          .toUpperCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");

        httpServiceUser.userService
          .changeAddressPoint(
            this.customer.company_id,
            this.selectedPoint,
            Cookies.get("token")
          )
          .then(response => {
            if (response.status == 200 || response.status == 204) {
              this.sendAddressError = null;
              // this.selectedPoint.address.street_name =
              //   this.selectedPoint.address.street_detail +
              //   this.selectedPoint.address.street_name;
              this.getAddressPoints();
            } else {
              this.sendAddressError = { code: "NOT_SENT" };
              // this.selectedPoint.address.street_name =
              //   this.selectedPoint.address.street_detail +
              //   this.selectedPoint.address.street_name;
            }
              this.closeAndOpenPopup();
          })
          .catch(error => {
            if (error.response) {
              this.sendAddressError = { code: "NOT_SENT" };
              // this.selectedPoint.address.street_name =
              //   this.selectedPoint.address.street_detail +
              //   this.selectedPoint.address.street_name;
              // this.companyDataError = { description: error.response.status };
            } else {
              this.sendAddressError = { code: "NOT_SENT" };
              // this.selectedPoint.address.street_name =
              //   this.selectedPoint.address.street_detail +
              //   this.selectedPoint.address.street_name;
            }
            this.closeAndOpenPopup();
          });
      }
    },
    closeAndOpenPopup() {
      this.showModalPopup("modal_popup_loading", false);
      // this.showModalPopup("modal_popup_confirm", false);
      this.showModalPopup("modal_popup_info", true);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  },
  created() {
    this.selectProduct(0);
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.token = Cookies.get("token");
  }
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
